import styled from 'styled-components';

export const MultiImagesDisplayContainer = styled.div`
    text-shadow: black 0px 0px 5px;
    width: ${window.screen.width <= 1000 ? '95%' : '90%'}; 
    height: auto;
    padding: 2vh 0 0 2vh;
    display: flex;
    justify-content: space-around;
    align-items: space-around;
    align-self: center;
    flex-wrap: wrap;
    

    .display {
        text-decoration: inherit;
        width: 450px;
        max-width: 90%;
        height: 60vh;
        border: solid rgba(255,255,255,0.1) 0.1px;
        margin: 1.5vh 0 1.5vh 0;
        display: flex;
        flex-direction: column;
        align-items: center;
        overflow: hidden;

        .display-frame {
            width: 100%;
            height: 100%;
            box-shadow: black 0px 0px 10px;
            display: flex;
            justify-content: center;
            background-repeat: no-repeat;
            background-position: center;
            background-size: cover;

            &:hover {
                cursor: pointer;
                // transition: transform 0.5s cubic-bezier(0.25, 0.45, 0.45, 0.95);
                // transform: skewY(1.5deg)
            };

            .header-info {
                color: white;
                background-image: linear-gradient(170deg, 
                    rgba(0,0,0,0.1), 
                    rgba(0,0,0,0.3), 
                    rgba(0,0,0,0.6), 
                    rgba(0,0,0,0.3), 
                    rgba(0,0,0,0.5), 
                    rgba(0,0,0,0.1)
                );
                width: 85%;
                // padding-top: 3em;
                margin: 2%;
                // text-align: center;
                display: flex;
                flex-direction: column;
                // justify-content: flex-end;
                position: relative;
                top: 65%;

                h2 {
                    font-size: ${window.screen.width <= 1000 ? '1.5em' : '2.1em'}; 
                    padding: 0;
                    margin: 0;
                }
                
                p {
                    font-size: ${window.screen.width <= 1000 ? '20px' : '25px'}; 
                }

                &:hover {
                    cursor: pointer;
                    transition: tone;
                    transform: none;
                };
            }
        }

    }
    
`;